import React, { FunctionComponent } from 'react'
import Box from '@material-ui/core/Box'
import { MyReservationsProvider } from 'components/views/my-reservations/MyReservationsProvider'
import Message, { MessageProvider } from 'components/elements/Message'
import Toolbar from 'components/views/my-reservations/partials/Toolbar'
import List from 'components/views/my-reservations/partials/List'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const MyReservations: FunctionComponent<AllProps> = ({}) => {
  return (
    <Box p={1.5}>
      <MyReservationsProvider>
        <MessageProvider>
          <Toolbar />
          <List />
          <Message />
        </MessageProvider>
      </MyReservationsProvider>
    </Box>
  )
}

export default MyReservations
